import { useEffect, useRef } from "react";
import Lenis from "lenis";

/**
 * Initialisiert Lenis einmalig für die gesamte App und gibt eine Ref auf die
 * Instanz zurück (null bei `prefers-reduced-motion`). Anker-Links werden per
 * Delegation abgefangen, damit auch nachträglich gerenderte Abschnitte greifen.
 */
export function useLenis() {
  const lenisRef = useRef(null);

  useEffect(() => {
    const prefersReduced = window.matchMedia(
      "(prefers-reduced-motion: reduce)"
    ).matches;
    if (prefersReduced) return;

    const lenis = new Lenis({
      duration: 1.15,
      easing: (t) => Math.min(1, 1.001 - Math.pow(2, -10 * t)),
      smoothWheel: true,
      touchMultiplier: 1.6,
    });
    lenisRef.current = lenis;

    let rafId;
    function raf(time) {
      lenis.raf(time);
      rafId = requestAnimationFrame(raf);
    }
    rafId = requestAnimationFrame(raf);

    const handleAnchor = (e) => {
      const anchor = e.target.closest('a[href^="#"]');
      if (!anchor) return;
      const href = anchor.getAttribute("href");
      if (!href || href === "#") return;
      const el = document.querySelector(href);
      if (!el) return;
      e.preventDefault();
      // Lenis rechnet den scroll-margin des Ziels selbst ein (index.css,
      // wächst mit der Kopfhöhe). Der Versatz kommt noch obendrauf.
      lenis.scrollTo(el, { offset: -100, duration: 1.4 });
    };
    document.addEventListener("click", handleAnchor);

    return () => {
      cancelAnimationFrame(rafId);
      document.removeEventListener("click", handleAnchor);
      lenis.destroy();
      lenisRef.current = null;
    };
  }, []);

  return lenisRef;
}
